import paymentInstance from '../instance'

const getPayPalNotification = () => {
	return paymentInstance.get('/paypalNotification')
}

export default getPayPalNotification
